import React, { FC } from 'react'
import { Learn, Locations, ProgramDetails } from '../components/Apply'
import FAQPage from '../components/Apply/FAQ'

const Apply: FC = () => {
  return (
    <>
      <FAQPage />
      <ProgramDetails />
      <Learn />
      <Locations />
    </>
  )
}

export default Apply
